import TechHero from "../components/TechHero";
import { CONTACT_INFO } from "../config/constants";

export default function CookiePolicy() {
  return (
    <div className="space-y-8 pb-16">
      <TechHero
        kicker="Legal"
        title="Cookie Policy"
        subtitle="How we use cookies to improve your experience"
      />

      <section className="max-w-4xl mx-auto space-y-6 text-white/90">
        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">1. Overview</h2>
          <p>
            This Cookie Policy explains how ZS NEXATECH uses cookies and similar technologies on our website. By using our site, you agree to the use of cookies as described here.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">2. What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device that help websites remember your preferences, improve performance, and analyze usage patterns.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">3. Types of Cookies We Use</h2>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li><strong>Essential Cookies:</strong> Required for core site functionality and security.</li>
            <li><strong>Performance Cookies:</strong> Help us understand how visitors use the site to improve speed and usability.</li>
            <li><strong>Analytics Cookies:</strong> Used to measure traffic and engagement (e.g., Google Analytics).</li>
            <li><strong>Preference Cookies:</strong> Remember settings like language or form entries where applicable.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">4. How to Manage Cookies</h2>
          <p>
            You can control or delete cookies through your browser settings. Disabling cookies may impact certain features or functionality of the website.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">5. Third-Party Cookies</h2>
          <p>
            We may use trusted third-party services (such as analytics providers) that set their own cookies to help us improve the site. These providers have their own privacy and cookie policies.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">6. Updates to This Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. The latest version will always be available on this page.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">7. Contact Us</h2>
          <p>
            If you have questions about our Cookie Policy, contact us at <strong>{CONTACT_INFO.email}</strong>.
          </p>
        </div>

        <div className="pt-4 border-t border-white/20">
          <p className="text-sm text-white/60">
            Last Updated: February 2026.
          </p>
        </div>
      </section>
    </div>
  );
}
